import { render, staticRenderFns } from "./LoadingDonorSummaryCard.vue?vue&type=template&id=042acc6d&"
import script from "./LoadingDonorSummaryCard.vue?vue&type=script&lang=ts&"
export * from "./LoadingDonorSummaryCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports